export default "__VITE_ASSET__CfsnqH77__"